import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';

import { DataService } from 'src/app/core/services/data.service';

import { IHttpService } from 'src/app/core/services/ihttp.service';

@Component({
  selector: 'dq-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit {
  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private dataService: DataService,
    @Inject('HttpService') private httpService: IHttpService,
    translate: TranslateService
  ) {}

  brands: any[] = [];
  subbrands: any[] = [];
  lines: any[] = [];
  formats: any[] = [];

  public isCollapsed = false;

  ngOnInit(): void {
    /*
    this.httpService
      .get(this.apiEndpointsService.getBrandsEndpoint())
      .subscribe((br) => {
        this.brands = br;
      });
      */
  }

  showhideFilters() {
    /*this.dataService.sendShowHideFilters();*/
  }

  changeBrand(item: any) {
    /*    if (item) {
      this.httpService
        .get(this.apiEndpointsService.getSubBrandsByBrandEndpoint(item.BRANDID))
        .subscribe((subbrands) => {
          this.subbrands = subbrands.subbrands;
        });
    } else this.subbrands = [];
    */
  }

  changeSubBrand(subbrand: any) {
    /*if (subbrand) {
      this.httpService
        .get(
          this.apiEndpointsService.getSubBrandsByBrandEndpoint(
            subbrand.SUBBRANDID
          )
        )
        .subscribe((lines) => {
          this.lines = lines.lines;
        });
    } else this.lines = [];
    */
  }

  changeLine(line: any) {
    /*if (line) {
      this.httpService
        .get(this.apiEndpointsService.getSubBrandsByBrandEndpoint(line.LINEID))
        .subscribe((formats) => {
          this.formats = formats.formats;
        });
    } else this.formats = [];*/
  }
}
